import sessionPayload from '@hc-frontend/shared-assets/src/js/sem/session-manager/sessionPayload'
import getSession from '@hc-frontend/shared-assets/src/js/sem/session-manager/getSession'
import { deepClone } from '@hc-frontend/utils'
import proxyStorage from 'proxy-storage'
import { convertToMember } from 'utils/pivot/member/convertToMember/convertToMember' // cspell:disable-line

const FORCE_NEW_SESSION = true

function updateSessionWithEmail(email) {
  const payload = deepClone(sessionPayload)
  payload.Email = email

  return getSession(payload, FORCE_NEW_SESSION).then(response => {
    if (response.hcStorage.members) {
      response.hcStorage.members = convertToMember(response.hcStorage.members)
    }
    proxyStorage.setItem('hc', response.hcStorage)

    return response.hcStorage
  })
}

export default updateSessionWithEmail
